import HeaderTitle from './header-title';

export default HeaderTitle;
